import { combineReducers, createStore, compose, applyMiddleware } from "redux";
import { SubAppConfig } from "../../../reducers/subAppsConfig.reducer";
import { activeSubApps } from "../reducers/activeSubApps.reducer";
import { selectedSubApp } from "../reducers/selectedSubApp.reducer";
import {
    skeletonStore,
    skeletonStoreSelectors,
    logger,
    crashReporter
} from "../../../store";
import { HomeActionCreators } from "../actions/actionCreators";
import _ from "lodash";
import { userInfo, userLoading } from "../reducers/userInfo.reducer";
import createSagaMiddleware from "@redux-saga/core";
import rootSaga from "../sagas";
import { createBrowserHistory } from "history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import {User} from "../../auth/reducers/users.reducer";

export const history = createBrowserHistory();

export interface HomeState {
    activeSubApps: SubAppConfig[];
    selectedSubApp: SubAppConfig;
    userInfo: User;
}

const homeReducer = combineReducers({
    router: connectRouter(history),

    activeSubApps,
    selectedSubApp,
    userInfo,
    userLoading
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Home Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const homeStore = createStore(
    homeReducer,
    {},
    composeEnhancers(
        applyMiddleware(
            routerMiddleware(history),
            sagaMiddleware,
            logger,
            crashReporter
        )
    )
);

export const homeStoreSelectors = {
    activeSubApps: (state = homeStore.getState()) => state.activeSubApps,
    selectedSubApp: (state = homeStore.getState()) => state.selectedSubApp,
    userInfo: (state = homeStore.getState()) => state.userInfo,
    userLoading: (state = homeStore.getState()) => state.userLoading
};

skeletonStore.subscribe(() => {
    const skeletonActiveSubApps = skeletonStoreSelectors.activeSubApps();
    const homeActiveSubApps = homeStoreSelectors.activeSubApps();

    if (
        !_.isEqual(_.sortBy(skeletonActiveSubApps), _.sortBy(homeActiveSubApps))
    ) {
        homeStore.dispatch(
            HomeActionCreators.updateSubApps(skeletonActiveSubApps)
        );
    }
});

sagaMiddleware.run(rootSaga);
